"use client";

import type { PriorityId } from "@/lib/types";

export function PriorityIcon({
  priority,
  size = 14,
}: {
  priority: PriorityId;
  size?: number;
}) {
  if (priority === 1) {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" aria-label="Urgent">
        <rect x="1" y="1" width="14" height="14" rx="3" fill="#eb5757" />
        <rect x="7" y="3" width="2" height="6" rx="1" fill="white" />
        <rect x="7" y="11" width="2" height="2" rx="1" fill="white" />
      </svg>
    );
  }

  if (priority === 0) {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" aria-label="No priority">
        <rect x="2" y="7" width="3" height="2" rx="1" fill="#62666d" />
        <rect x="6.5" y="7" width="3" height="2" rx="1" fill="#62666d" />
        <rect x="11" y="7" width="3" height="2" rx="1" fill="#62666d" />
      </svg>
    );
  }

  const bars =
    priority === 2 ? [1, 1, 1] : priority === 3 ? [1, 1, 0] : [1, 0, 0];
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-label={`Priority ${priority}`}>
      <rect x="2" y="10" width="3" height="4" rx="1" fill={bars[0] ? "#b4bcd0" : "#3a3d44"} />
      <rect x="6.5" y="7" width="3" height="7" rx="1" fill={bars[1] ? "#b4bcd0" : "#3a3d44"} />
      <rect x="11" y="4" width="3" height="10" rx="1" fill={bars[2] ? "#b4bcd0" : "#3a3d44"} />
    </svg>
  );
}
